"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactAgenda = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var ContactAgenda = function ContactAgenda() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.4 0h14.4a2.4 2.4 0 012.4 2.4v19.2a2.4 2.4 0 01-2.4 2.4H2.4A2.4 2.4 0 010 21.6V2.4A2.4 2.4 0 012.4 0zm9.9 8.4a2.7 2.7 0 00-2.7-2.7 2.688 2.688 0 00-2.7 2.7 2.7 2.7 0 005.4 0zm2.4 9.6H4.5a.9.9 0 01-.804-1.308L4.8 14.52a2.4 2.4 0 012.124-1.32h5.532a2.16 2.16 0 011.944 1.32l1.08 2.172A.9.9 0 0114.7 18zm6.9-15.6h1.2A1.2 1.2 0 0124 3.6v16.8a1.2 1.2 0 01-1.2 1.2h-1.2V2.4z",
    clipRule: "evenodd"
  });
};

exports.ContactAgenda = ContactAgenda;